// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3348":"8e21927870fa17ff","3674":"decefe951498debc"}[chunkId] + ".css";
};